import { useNavigate } from 'react-router-dom';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { CounselorDashboard } from '../../types/dashboard';

interface MyPersonalAppointmentsCardProps {
  data?: CounselorDashboard['personalAppointments'];
}

/** Counselor Dashboard's "My Personal Appointments" — today/upcoming/
 * pending-confirmation/completed, scoped to the logged-in Counselor. */
export const MyPersonalAppointmentsCard = ({ data }: MyPersonalAppointmentsCardProps) => {
  const navigate = useNavigate();
  const rows = [
    { label: "Today's appointments", value: data?.today ?? 0, color: 'primary.main' },
    { label: 'Upcoming', value: data?.upcoming ?? 0, color: 'info.main' },
    { label: 'Pending confirmation', value: data?.pendingConfirmation ?? 0, color: 'warning.main' },
    { label: 'Completed', value: data?.completed ?? 0, color: 'success.main' },
  ];

  return (
    <Paper sx={{ p: 2, height: '100%', cursor: 'pointer' }} onClick={() => navigate('/personal-appointments')}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        My Personal Appointments
      </Typography>
      <Stack direction="row" flexWrap="wrap" gap={3}>
        {rows.map((row) => (
          <Box key={row.label}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: row.color }}>
              {row.value}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {row.label}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
};
